import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Grid from '@material-ui/core/Grid';
import { Link } from '@material-ui/core';
import { M2U_APP_APPSTORE_URL, M2U_APP_PLAYSTORE_URL } from 'settings/constants/common';

const DownloadM2U = ({ imgDownloadM2U, imgPlayStore, imgAppStore }) => {
  const { formatMessage } = useIntl();

  return (
    <Grid container className="mt4">
      <Grid item xs={12} sm={12} md={12}>
        <Grid container direction="row" justify="center">
          <Grid>
            <img className src={imgDownloadM2U} alt="Download-M2U" />
          </Grid>
          <Grid direction="column" className="ml3">
            <h3 className="home--download">{formatMessage({ id: 'login.accessMobile' })}</h3>
            <Grid justify="center">
              <Link target="_blank" rel="noopener" href={M2U_APP_APPSTORE_URL}>
                <img src={imgAppStore} alt="App-Store" className="ml2 icon--download" />
              </Link>
              <Link href={M2U_APP_PLAYSTORE_URL} target="_blank" rel="noopener">
                <img src={imgPlayStore} alt="Play-Store" className="ml3 icon--download" />
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

DownloadM2U.propTypes = {
  imgDownloadM2U: PropTypes.string.isRequired,
  imgPlayStore: PropTypes.string.isRequired,
  imgAppStore: PropTypes.string.isRequired,
};

export default DownloadM2U;
